import { SET_SUPPRESS_PON_ACTION } from './actionTypes'

export function setResponseAction(ResponseAction)
{
    return {
        type: SET_SUPPRESS_PON_ACTION,
        payload: {
            value: ResponseAction,
        },
    };
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/response-handler-launch-message-process/actions/actions.ts